export const getVideoMetadata = (
  url: string,
): Promise<{ width: number; height: number; duration: number }> =>
  new Promise((resolve, reject) => {
    const videoNode = document.createElement('video');
    videoNode.onloadedmetadata = () =>
      resolve({
        width: videoNode.videoWidth,
        height: videoNode.videoHeight,
        duration: videoNode.duration,
      });

    videoNode.onerror = (event) => reject(event);
    videoNode.src = url;
  });
